<template>
  <div class="phone-icon">
    <wm-icon
      name="phone"
      class="phone-icon__icon"
      title="Telephone"
      :width="iconWidth"
      :height="iconHeight"
    />
    <CmsBlocks identifiers="store_phone" class="phone-icon__link" />
  </div>
</template>
<script>
import { defineComponent, onMounted, computed } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "PhoneIcon",
  props: {
    iconHeight: {
      type: String,
      default: "24",
    },
    iconWidth: {
      type: String,
      default: "24",
    },
  },
  components: {
    CmsBlocks: () => import("components/theme/Content/CmsBlocks.vue"),
  },
});
</script>
<style lang="scss">
.phone-icon {
  display: flex;
  align-items: center;
  margin-right: 2rem;
  color: var(--white);

  &__icon {
    margin-right: 0.375rem;
  }

  &__link {
    a {
      color: var(--white);
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
